import React, {useState} from "react";
import {Link, useHistory} from "react-router-dom";
import {useFormik} from "formik";
import * as Yup from "yup";
import {connect} from "react-redux";
/*import { FormattedMessage, injectIntl } from "react-intl";*/
import * as auth from "../_redux/authRedux";
import {login} from "../_redux/authCrud";
import {useTranslation} from "react-i18next";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
	email: "",
	password: "",
};

function Login(props) {

	const history = useHistory()
	/*  const { intl } = props;*/
	const {t} = useTranslation('common')
	const [loading, setLoading] = useState(false);
	const LoginSchema = Yup.object().shape({
		phone: Yup.string()
			.matches(/^09[0-9]{9}$/, t("AUTH.VALIDATION.INVALID_PHONE"))
			.required(
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			),
		password: Yup.string()
			.min(3, "Minimum 3 symbols")
			.max(50, "Maximum 50 symbols")
			.required(
				/*intl.formatMessage({
					id: "AUTH.VALIDATION.REQUIRED_FIELD",
				})*/
				t('AUTH.VALIDATION.REQUIRED_FIELD')
			),
	});

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	const getInputClasses = (fieldname) => {
		if (formik.touched[fieldname] && formik.errors[fieldname]) {
			return "is-invalid";
		}

		if (formik.touched[fieldname] && !formik.errors[fieldname]) {
			return "is-valid";
		}

		return "";
	};

	const formik = useFormik({
		initialValues,
		validationSchema: LoginSchema,
		onSubmit: (values, {setStatus, setSubmitting}) => {
			enableLoading();
			login(values.phone, values.password,t('lang'))
				.then(({data}) => {
					const {success,needVerify,token} = data || {}
					disableLoading();
					setSubmitting(false);
					if(success){
						if(needVerify){
							setTimeout(() => {
								history.push(`/auth/verifyPhone/${(values.phone)}`)
							}, 100)
							return
						}else{
							props.login({authToken: token});
						}
					}else{
						setStatus(
							/*intl.formatMessage({
								id: "AUTH.VALIDATION.INVALID_LOGIN",
							})*/
							t('AUTH.VALIDATION.INVALID_LOGIN')
						);
					}
				})
				.catch(() => {
					disableLoading();
					setSubmitting(false);
					setStatus(
						/*intl.formatMessage({
							id: "AUTH.VALIDATION.INVALID_LOGIN",
						})*/
						t('AUTH.VALIDATION.INVALID_LOGIN')
					);
				});
		},
	});

	return (
		<div className="login-form login-signin" id="kt_login_signin_form">
			{/* begin::Head */}
			<div className="text-center mb-10 mb-lg-20">
				<h3 className="font-size-h1">
					{/*<FormattedMessage id="AUTH.LOGIN.TITLE" />*/}
					{t('AUTH.LOGIN.TITLE')}
				</h3>
				<p className="text-muted font-weight-bold">
					{t('EnterEmail')}
				</p>
			</div>
			{/* end::Head */}

			{/*begin::Form*/}
			<form
				onSubmit={formik.handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{formik.status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{formik.status}</div>
					</div>
				) : null
				}

				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.PHONE')}
						type="tel"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"phone"
						)}`}
						name="phone"
						{...formik.getFieldProps("phone")}
					/>
					{formik.touched.phone && formik.errors.phone ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.phone}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder="Password"
						type="password"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"password"
						)}`}
						name="password"
						{...formik.getFieldProps("password")}
					/>
					{formik.touched.password && formik.errors.password ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.password}</div>
						</div>
					) : null}
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<Link
						to="/auth/forgot-password"
						className="text-dark-50 text-hover-primary my-3 mr-2"
						id="kt_login_forgot"
					>
						{/*<FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />*/}
						{t('AUTH.GENERAL.FORGOT_BUTTON')}
					</Link>
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={formik.isSubmitting}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('Login')}</span>
						{loading && <span className="ml-3 spinner spinner-white"></span>}
					</button>
				</div>
			</form>
			{/*end::Form*/}
		</div>
	);
}

export default (connect(null, auth.actions)(Login));
